"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyTermsService = void 0;
class AirwebTicketLegacyTermsService {
    constructor(client) {
        this.client = client;
    }
    async getLegalNotice(networkId, options = {}) {
        const response = (await this.client.http
            .get('Terms/getLegalNotice.json', Object.assign({ params: { networkId } }, options))
            .catch(this.handleError));
        return response.data.notice;
    }
    async getTermsOfUse(networkId, options = {}) {
        const response = (await this.client.http
            .get('Terms/getTermsOfUse.json', Object.assign({ params: { networkId } }, options))
            .catch(this.handleError));
        return response.data.terms;
    }
    async getPrivacyPolicy(networkId, options = {}) {
        const response = (await this.client.http
            .get('Terms/getPrivacyPolicy.json', Object.assign({ params: { networkId } }, options))
            .catch(this.handleError));
        return response.data.privacyPolicy || '';
    }
    handleError(error) {
        throw error;
    }
}
exports.AirwebTicketLegacyTermsService = AirwebTicketLegacyTermsService;
//# sourceMappingURL=terms.service.js.map